<template>
  <div class="courseWrap">
    <div>
      <h5 class="titles"><b>总学习概览</b></h5>
      <v-item-group selected-class="bg-primary">
        <md-content class="md-scrollbar md-layout">
          <div
            v-for="item in courseList"
            cols="auto"
            :key="item._id"
            class="md-layout-item md-xlarge-size-25 md-large-size-25 md-medium-size-25 md-small-size-25 md-xsmall-size-100 courseItem"
          >
            <v-item v-slot="{ isSelected, selectedClass, toggle }">
              <v-card :class="['d-flex align-center', selectedClass]" height="100" @click="toggle">
                <div class="conWrap">
                  <div class="leftCon">
                    <img :src="item.courseImg" alt="" width="80px" />
                  </div>

                  <div class="rightCon">
                    <h5>{{ item.collectNum }}</h5>
                    <p>{{ item.tostudy }}</p>
                  </div>
                </div>
              </v-card>
            </v-item>
          </div>
        </md-content>
      </v-item-group>
    </div>

    <div style="padding-bottom:20px;">
      <div class="chartsWrap">
        <div class="leftChartsWrap">
          <horizontalBar />
        </div>
        <div class="rightChartsWrap">
          <radarChar />
        </div>
      </div>
      <div class="learDataWrap">
        <h5 class="titles"><b>具体学习数据</b></h5>
        <div  class="dataWrap">
            <v-tabs 
          fixed-tabs
          v-model="tab"
          color="green"
          class="custom-tab1"
          :items="false"
          align-tabs="center"
          :border='true'
          

        >
          <v-tab :value="item.value" v-for="(item, index) in tabs" :key="index">{{
            item.label
          }}</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" >
          <v-tab-item v-for="(item, index) in tabs" :key="index">
            <div
              style="width: 100%; height: 200px; background: #fff; height: auto; overflow: hidden"
            >
              <ul class="learDataConWrap">
                <li>
                  <p>学习时长</p>
                  <p>{{ item.children.learningDuration }}</p>
                </li>

                <li>
                  <p>课程排名</p>
                  <p>{{ item.children.courseRanking }}</p>
                </li>

                <li>
                  <p>获得学习力</p>
                  <p>{{ item.children.learningAbility }}</p>
                </li>

                <li>
                  <p>完成任务数</p>
                  <p>{{ item.children.tasksNum }}</p>
                </li>
                <li>
                  <p>知识点掌握度</p>
                  <p>{{ item.children.knowledgePoints }}</p>
                </li>

                <li>
                  <p>学习次数</p>
                  <p>{{ item.children.learningFrequency }}</p>
                </li>

                <li>
                  <p>平均操作时长</p>
                  <p>{{ item.children.AverageTime }}</p>
                </li>

                <li>
                  <p>获得经验值</p>
                  <p>{{ item.children.experiencePoints }}</p>
                </li>

                <li>
                  <p>完成率</p>
                  <p>{{ item.children.completionRate }}</p>
                </li>

                <li>
                  <p>测试准确率</p>
                  <p>{{ item.children.testAccuracy }}</p>
                </li>
              </ul>
            </div>
          </v-tab-item>
        </v-tabs-items>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import horizontalBar from './echarts/horizontalBar.vue';
import radarChar from './echarts/radarChar.vue';
export default {
  // name:'learningCourses',历史学习
  components: {
    horizontalBar,
    radarChar,
  },
  data() {
    return {
      courseList: [
        {
          _id: '1',
          courseName: '建筑电器施工技术',
          collectNum: '20',
          tostudy: '分钟',
          courseImg: require('@/assets/mylearing/leartime.png'),
        },
        {
          _id: '2',
          courseName: '建筑电器施工技术',
          collectNum: '120',
          tostudy: '门课程',
          courseImg: require('@/assets/mylearing/learcourse.png'),
        },
        {
          _id: '3',
          courseName: '建筑电器施工技术',
          collectNum: '320',
          tostudy: '个任务',
          courseImg: require('@/assets/mylearing/leartask.png'),
        },
        {
          _id: '4',
          courseName: '建筑电器施工技术',
          collectNum: '20',
          tostudy: '个知识点',
          courseImg: require('@/assets/mylearing/learbar.png'),
        },
      ],
      tabs: [
        {
          label: '建筑电气施工',
          value: '0',
          children: {
            learningDuration: 200, //学习时长
            courseRanking: 20, //课程排名
            learningAbility: 80, //获得学习力
            tasksNum: 75, //完成任务数
            knowledgePoints: '20%', //知识点掌握度
            learningFrequency: 20, //学习次数
            AverageTime: 80, //平均操作时长
            experiencePoints: 802, //获得经验值
            completionRate: '89%', //完成率
            testAccuracy: '75%', //测试准确率
          },
        },
        {
          label: '高压电技术',
          value: '1',
          children: {
            learningDuration: 200, //学习时长
            courseRanking: 20, //课程排名
            learningAbility: 80, //获得学习力
            tasksNum: 75, //完成任务数
            knowledgePoints: '20%', //知识点掌握度
            learningFrequency: 20, //学习次数
            AverageTime: 80, //平均操作时长
            experiencePoints: 802, //获得经验值
            completionRate: '89%', //完成率
            testAccuracy: '75%', //测试准确率
          },
        },
        {
          label: '化工厂配电',
          value: '2',
          children: {
            learningDuration: 200, //学习时长
            courseRanking: 20, //课程排名
            learningAbility: 80, //获得学习力
            tasksNum: 75, //完成任务数
            knowledgePoints: '20%', //知识点掌握度
            learningFrequency: 20, //学习次数
            AverageTime: 80, //平均操作时长
            experiencePoints: 802, //获得经验值
            completionRate: '89%', //完成率
            testAccuracy: '75%', //测试准确率
          },
        },
        {
          label: '城市污水处理',
          value: '3',
          children: {
            learningDuration: 200, //学习时长
            courseRanking: 20, //课程排名
            learningAbility: 80, //获得学习力
            tasksNum: 75, //完成任务数
            knowledgePoints: '20%', //知识点掌握度
            learningFrequency: 20, //学习次数
            AverageTime: 80, //平均操作时长
            experiencePoints: 802, //获得经验值
            completionRate: '89%', //完成率
            testAccuracy: '75%', //测试准确率
          },
        },
      ],
      tab: 0,
    };
  },
};
</script>

<style scoped>
.courseWrap {
  width: 100%;
  height: auto;
  overflow: hidden;
}

.courseItem {
  margin: 10px 0;
}

.titles {
  padding: 0 20px;
  font-weight: bold;
}

.conWrap {
  height: 100px;
  width: 100%;
}

.leftCon {
  width: 40%;
  height: 100px;
  line-height: 100px;
  float: left;
  text-align: center;
  /* background: green; */
}
.leftCon img {
  width: 80px;
}

.rightCon {
  display: block;
  float: left;
  width: 60%;
  height: auto;
  height: 100px;
  /* background: red; */
  text-align: center;
}
.rightCon h5 {
  color: #5db461;
  font-weight: bold;
  margin-top: 20px;
  line-height: 15px;
}

.rightCon p {
  margin-bottom: 0px;
}

.chartsWrap {
  width: 100%;
  height: 340px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.leftChartsWrap {
  width: 50%;
  height: 320px;
}

.rightChartsWrap {
  width: 50%;
  height: 320px;
}

.learDataWrap {
  width: 100%;
  height: auto;
}

.learDataConWrap {
  list-style-type: none;
  display: flex;
  justify-content: center;
 align-items: flex-start; /* Y轴上的项目顶部对齐 */
  width: 100%;
  height: auto;
  flex-wrap: wrap;
  padding: 0px;
}
.learDataWrap li {
  height: 80px;
  /* background: pink; */
  width: 20%;
  display: flex;
  flex-wrap: wrap;
  align-items: self-end;
}
.learDataWrap li p {
  width: 80%;
  margin: 0 auto;
  text-align: left;
}
.learDataWrap li p:nth-child(1) {
  font-size: 13px;
}
.learDataWrap li p:nth-child(2) {
  font-size: 19px;
  font-weight: bold;
  color: #5db461;
}


>>> .v-slide-group__wrapper  .v-tab--active{
  background: #5db461 !important;
  color:  #fff;
}
>>> .v-slide-group__wrapper  .v-tab{
  border:1px solid #5db461 !important;
  border-left: none;

}

/* >>> .v-slide-group__wrapper  .v-tab */
.dataWrap{
  border:1px solid #5db461;
    border-top: none;
}


</style>
